<template>
  <span
    class="inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-all duration-150 ease-in-out"
    :class="
      isSelected
        ? 'bg-primary/20 dark:bg-primary/20 text-primary dark:text-primary border-primary/30 dark:border-primary/30'
        : 'border-lightSecondaryColor bg-lightSecondaryColor text-lightPrimaryTextColor dark:border-darkSecondaryColor dark:bg-darkSecondaryColor dark:text-darkPrimaryTextColor'
    "
  >
    {{ sectionName }}
  </span>
</template>

<script setup lang="ts">
interface Props {
  sectionName: string;
  isSelected: boolean;
}

defineProps<Props>();
</script>
